/**
 * Public Beatly legal pages. These URLs are intentionally kept in one place so
 * the product never falls back to a placeholder link for required legal copy.
 */
export const BEATLY_PRIVACY_POLICY_URL = 'https://www.beatly.com/info/privacy-policy';
export const BEATLY_TERMS_OF_SERVICE_URL = 'https://www.beatly.com/info/terms-of-service';
/**
 * The full client AI terms the Omni studios ask a client team to accept (cowork GET /v1/me/terms). Until legal
 * publishes their own page, VITE_CLIENT_AI_TERMS_URL can point elsewhere; the terms of service are the fallback.
 */
export const CLIENT_AI_TERMS_URL: string =
  (import.meta.env.VITE_CLIENT_AI_TERMS_URL as string | undefined) || BEATLY_TERMS_OF_SERVICE_URL;
